import { render, staticRenderFns } from "./ItemTabCustomerItems.vue?vue&type=template&id=14db646c&scoped=true"
import script from "./ItemTabCustomerItems.vue?vue&type=script&lang=ts"
export * from "./ItemTabCustomerItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14db646c",
  null
  
)

export default component.exports